
import React, { useEffect, useState } from "react";
import { FormProvider, useForm } from 'react-hook-form';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHome } from "@fortawesome/free-solid-svg-icons";
import { Badge, Breadcrumb, Button, Card, Form, Table } from '@themesberg/react-bootstrap';
import { confirmDeleteToast, sendError, sendSuccess } from "../helpers/Helper";
import { API_URL_ENDPOINT } from "../appsetting";
import CustomPagination from "../components/CustomPagination";
import { useNavigate} from "react-router-dom";
import { Routess } from "../Routes/routes";
import { Avatar } from "@mui/material";
import { useApi } from "../helpers/useApi";

export const Transporters = () => {
  const callApi = useApi();
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");

  const [dataLoading, setDataLoading] = useState(false);
  const [data, setData] = useState({
    items:[],
    pageNo : 1,
    pageSize : 10,
    totalPage : 0,
    totalRecords : 0,
  });

  useEffect(()=>{
    getData();
  },[])

  const handlePageChange = (newPage) =>{    
    getData(newPage);
  }

  const getData = async (cp = null) => {
    try{
      setDataLoading(true);
      const response = await callApi(API_URL_ENDPOINT.Transporter+`?pageNo=${cp ?? data.pageNo}&pageSize=${data.pageSize}`);
      if(response.status){
        setData(response.data);
      }
    }catch{
      setData([]);
    }finally{
      setDataLoading(false);
    }
  }

  const handleView = (id) => {
    navigate(Routess.NewsAndEvent.path + `/${id}`)
  }

  const handleDelete = () => {
    confirmDeleteToast(() => {
      sendSuccess("Deleted successfully!");
    });
  };

  return (
    <>
      <div className="justify-content-between d-flex flex-wrap flex-md-nowrap align-items-center py-4">
        <div className="d-block mb-4 mb-xl-0">
          <Breadcrumb className="d-none d-md-inline-block" listProps={{ className: "breadcrumb-dark breadcrumb-transparent" }}>
            <Breadcrumb.Item><FontAwesomeIcon icon={faHome} /></Breadcrumb.Item>
            {/* <Breadcrumb.Item>NPSP</Breadcrumb.Item> */}
            <Breadcrumb.Item active>Transporters</Breadcrumb.Item>
          </Breadcrumb>
          <div className="d-flex align-items-center justify-content-between">
            <h4 className="mb-0">Transporters</h4>
          </div>
        </div>
        <div className="w-25">
          <Form.Control value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} onKeyDown={(e) => {if (e.key === "Enter") getData(1);}} type="text" className="shadow-none" placeholder={"Search..."} />
        </div>
      </div>

      <Card border="light" className="shadow-sm mb-4">
        <Card.Body className="pb-0">
          {dataLoading ? (
            <div className="text-center my-3">
              <span className="spinner-border text-primary" role="status"></span>
            </div>
          ) : (
            <Table responsive className="table-centered table-nowrap rounded mb-0">
              <thead className="thead-light">
                <tr>
                  <th className="border-0 text-center">#</th>
                  <th className="border-0 text-center">Full Name</th>
                  <th className="border-0 text-center">phoneNumber</th>
                  <th className="border-0 text-center">Address</th>
                  <th className="border-0 text-center">Status</th>
                  <th className="border-0 text-end pe-4">Action</th>
                </tr>
              </thead>
              <tbody>
                {data?.items?.length > 0 ? (
                  data.items.map((item, index) => (
                    <tr key={index}>
                      <td className="text-center align-middle">
                        {(data.pageNo - 1) * data.pageSize + index + 1}
                      </td>
                      <td className="fw-bold align-middle text-center">{item.fullName}</td>
                      <td className="fw-bold align-middle text-center">{item.phoneNumber}</td>
                      <td className="fw-bold align-middle text-center">{item.address}</td>
                      <td className="align-middle text-center">{item.isActive ? 'Active' : 'InActive' }</td>
                      <td className="text-end align-middle">
                        <Button variant="primary" className="btn-sm" onClick={()=>handleView(item.id)}>View Details</Button>
                        {/* <Button onClick={handleDelete} variant="danger" className="btn-sm">Remove</Button> */}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="6" className="text-center">No Data Found</td>
                  </tr>
                )}
              </tbody>
            </Table>
          )}
        <div className="d-flex justify-content-end">
          <CustomPagination totalRecord={data.totalRecords} totalPages={data.totalPage} loading={dataLoading} onPageChange={handlePageChange}/>
        </div>
        </Card.Body>
      </Card>
    </>
  );
};
